export default __webpack_public_path__ + "static/media/badge.fda2c093.png";